// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3cRNB","content":"styles_content__2J19B","selectAll":"styles_selectAll__Pyakc"};